import React from 'react';

const OrderITem = (props) => {
    const {name, price, image} = props.tour;

    return (
        <div>
            <img style={{width:'200px'}} src={image} alt="" />
            <h3 className="my-3">{name}</h3>
            <h6>Price: ${price}</h6>
            <button onClick={()=> props.handleAddBuyNow(props.tour)} className="btn my-3">Buy Now</button>
        </div>
    );
};

export default OrderITem;